import FullScreenBanner from '@/components/full-screen-banner'
import banner from '@/assets/img/solution/disaster-relief/banner.jpg'
import Styles from './style.module.scss'

const TITLE = 'Reliable Power for Disaster Relief'
const DESCRIPTION = 'When hurricanes, floods, earthquakes, or wildfires strike, Carus delivers\nfast-deployable solar + energy storage + mobile power to keep critical\noperations running'

export default function Banner() {
  return (
    <FullScreenBanner image={banner} className={Styles.banner} vertical>
      <h2>{TITLE}</h2>
      <div className={Styles.description}>{DESCRIPTION}</div>
    </FullScreenBanner>
  )
}
